import { Box, Button } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";
import { PaperTitle } from "Components/Shared/PaperTitle";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  title: string;
  onEditClick: () => void;
  isEditingDisabled?: boolean;
};

/** Section title with an Edit action, for the self-service account sections that open a form dialog. */
export const EditableSectionHeader = ({
  title,
  onEditClick,
  isEditingDisabled,
}: Props) => {
  const { t } = useResource();

  return (
    <Box
      component="legend"
      // Everything stays in sx on purpose: MUI merges system props (mb, display…) BEFORE sx, so the
      // legend reset would land after them and wipe them out. Same pattern as FormSection.
      sx={{
        all: "unset",
        mb: 2,
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <PaperTitle component="span" p={0}>
        {title}
      </PaperTitle>
      <Button
        variant="text"
        onClick={onEditClick}
        disabled={isEditingDisabled}
        sx={{
          fontSize: "0.875rem",
          fontWeight: 600,
          color: Colors.Link,
          textTransform: "none",
          py: 0,
          px: 2,
          minWidth: 0,
          mr: -2,
        }}
      >
        {t(Resources.Common.Edit)}
      </Button>
    </Box>
  );
};
